import { jsx as t } from "react/jsx-runtime";
import { Fragment as s } from "react";
import { Tfoot as a, Box as f } from "@chakra-ui/react";
import { flexRender as i } from "@tanstack/react-table";
import { Tr as p } from "./Tr/Tr.mjs";
import { Td as d } from "./Td/Td.mjs";
const b = ({
  expandRowId: n,
  isMobile: c,
  showPaginationFooter: m,
  table: u
}) => /* @__PURE__ */ t(a, { children: u.getFooterGroups().map((o) => /* @__PURE__ */ t(s, { children: /* @__PURE__ */ t(
  p,
  {
    _last: m ? {
      "> td": {
        _first: { borderBottomLeftRadius: "none" },
        _last: { borderBottomRightRadius: "none" }
      }
    } : {
      "> td": {
        borderBottom: "none",
        _first: { borderBottomLeftRadius: "lg" },
        _last: { borderBottomRightRadius: "lg" }
      }
    },
    ...m && {
      borderBottomWidth: "1px"
    },
    children: c ? /* @__PURE__ */ t(d, { colSpan: 2, children: o.headers.map((r) => {
      if (r.id !== n && r.column.columnDef.footer !== void 0)
        return /* @__PURE__ */ t(f, { children: i(r.column.columnDef.footer, r.getContext()) }, r.id);
    }) }) : o.headers.map((r) => {
      var e;
      return /* @__PURE__ */ t(d, { isNumeric: (e = r.column.columnDef.meta) == null ? void 0 : e.isNumeric, children: i(r.column.columnDef.footer, r.getContext()) }, r.id);
    })
  }
) }, o.id)) });
export {
  b as Tfoot
};
